import { describeKnowledgeApiError } from 'utils/knowledgeErrors';
import {
  UpdateSupplementKnowledgeExpandSpuParams,
  updateSupplementKnowledgeExpandSpu,
} from 'services/api/supplementKnowledge';
import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

export const useUpdateExpandSpu = (knowledgeId: number) => {
  const { t } = useTranslate();
  const { mutateAsync: updateSpuMutation, isLoading } = useMutation({
    mutationFn: ({
      action,
      spuList,
    }: {
      action: UpdateSupplementKnowledgeExpandSpuParams['action'];
      spuList: UpdateSupplementKnowledgeExpandSpuParams['spuList'];
    }) => {
      return updateSupplementKnowledgeExpandSpu({
        knowledgeId,
        action,
        spuList,
      });
    },
    onError: (knowledgeError) => {
      message.error(
        describeKnowledgeApiError(knowledgeError, undefined, t('translation.操作失败，请稍后再试')),
      );
    },
  });

  return {
    isLoading,
    updateSpuMutation,
  };
};
